export default __webpack_public_path__ + "static/sergiuszr-bb4897b9ca58f74cf9f4c3cbd62ccdb7.png";